import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export const WorkshopError = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    role="alert"
    className={cn(
      "whitespace-pre-wrap rounded-lg border border-destructive/30 bg-destructive-soft px-4 py-3 text-sm text-destructive",
      className,
    )}
  >
    {children}
  </div>
);
